import React from "react";
import { Container } from "@mui/material";
import { Title, Button, blue, lightblue, Text } from "../theme/theme";

const Test = () => {
  return (
    <div style={{ background: lightblue, minHeight: "60vh" }}>
      <Container>
        <br />
        <br />
        <br />
        <Title color={blue}>Test</Title>
        <br />
        <Button to="https://tools.keycdn.com/performance?url=mee-tec.be" color={blue} external>
          <Text color={blue}>Run KeyCDN performance test</Text>
        </Button>
      </Container>
    </div>
  );
};

export default Test;
